/**
 * Colour picker for a mix-and-match pack: one radio group per piece.
 * `value` is the chosen colours in order ("Svart, Rosa, Vinrød"); `property` is the order line label.
 * Fires a bubbling `pack-change` event whenever a colour changes.
 */
class PackColourPicker extends HTMLElement {
  connectedCallback() {
    this.addEventListener('change', this.#update);
    this.#update();
  }

  disconnectedCallback() {
    this.removeEventListener('change', this.#update);
  }

  /** @returns {string[]} */
  get colours() {
    return [...this.querySelectorAll('[data-pack-piece]')]
      .map((row) => row.querySelector('input:checked'))
      .filter((input) => input instanceof HTMLInputElement)
      .map((input) => input.value);
  }

  get value() {
    return this.colours.join(', ');
  }

  get property() {
    return this.dataset.property || 'Farger';
  }

  #update = () => {
    for (const row of this.querySelectorAll('[data-pack-piece]')) {
      const checked = row.querySelector('input:checked');
      const label = row.querySelector('[data-pack-value]');
      if (label) label.textContent = checked instanceof HTMLInputElement ? checked.value : '';
    }
    this.dispatchEvent(new Event('pack-change', { bubbles: true }));
  };
}

if (!customElements.get('pack-colour-picker')) {
  customElements.define('pack-colour-picker', PackColourPicker);
}
